import NavigationHelper from "../assets/navigation-helper";
import {getFileHash} from '../assets/utils';
import {objectToFormData} from '../assets/forms';
import {fetchJson} from "../assets/request";
import translate from "../assets/translate";

class FileController {
  newFile;
  data;
  /** @var FilesController */
  controller;

  constructor(controller) {
    this.controller = controller;
    this.data = Alpine.reactive({
      loading: false
    })
  }

  async save(file) {
    this.data.loading = true;
    await fetchJson(this.controller.base_url, {
      method: 'POST',
      body: objectToFormData({
        type: 'save-document',
        id: file.id,
        document_type_id: file.document_type_id,
        title: file.title,
        description: file.description,
        machine_id: this.controller.options.machine_id,
      })
    }).finally(
      () => this.data.loading = false
    )
  }

  async delete(file) {

    this.data.loading = true;
    // TODO Datei löschen
    await fetchJson(this.controller.base_url, {
      method: 'POST',
      body: objectToFormData({
        type: 'remove-document',
        document_id: file.id,
        machine_id: this.controller.options.machine_id,
      })
    }).finally(
      () => this.data.loading = false
    )
    const index = this.controller.files.indexOf(file);
    if (index > -1) {
      this.controller.files.splice(index, 1);
    }
  }

  get isLoading() {
    return this.data.loading;
  }
}

class FilesController {

  files = [];
  options = {};
  _fileInput;
  data;

  constructor(files, options) {
    this.files = Alpine.reactive(files);
    this.options = options;
    this.data = Alpine.reactive({
      loading: false
    });

    if (!Number.isInteger(options.maxsize)) {
      if (options.maxsize.match(/^\d+m$/)) {
        options.maxsize = Number.parseInt(options.maxsize) * 1024 + 'kb';
      }
      if (options.maxsize.match(/^\d+kb$/)) {
        options.maxsize = Number.parseInt(options.maxsize) * 1024;
      }
      if (!Number.isInteger(options.maxsize)) {
        options.maxsize = Number.parseInt(options.maxsize);
      }
    }
    this.initNewfile()
  }

  set fileInput(fileInput) {
    fileInput.addEventListener('change', (e) => this.onFileInputChange(e));
    this._fileInput = fileInput;
  }

  get fileInput() {
    return this._fileInput;
  }

  get limitReached() {
    return this.options.limit <= this.files.length
  }

  async onFileInputChange(event) {
    let file = Object.values(this.fileInput.files).pop();
    this.newFile.file = file;
    this.newFile.title = this.newFile.title || file.title
    this.newFile.hash = file ? await getFileHash(file) : '';
    return this.uploadFile();
  }

  async uploadFile() {
    try {
      this.data.loading = true;
      //maxsize prüfen
      if (this.options.maxsize > 0 && this.options.maxsize < this.newFile.file.size) {
        //TODO: throw alert instead of error
        throw translate('tpWeb.frontend.global.machineDocuments.error.filesize');
        this.data.loading = false;
        return this.initNewfile();
      }
      //limit prüfen
      if (this.options.limit <= this.files.length) {
        //TODO: throw alert instead of error
        throw translate('tpWeb.frontend.global.machineDocuments.error.maxCountLimit');
        return this.initNewfile();
      }

      // TODO ansonsten mit Daten hochladen und Customer und Maschine hinzufügen
      const uploadresponse = await fetchJson(this.base_url, {
        method: 'POST',
        body: objectToFormData({
          type: 'upload',
          machine_id: this.options.machine_id,
          documents: this.fileInput.files[0],
          hash: this.newFile.hash,
          document_type_id: this.newFile.document_type_id,
          title: this.newFile.title || this.fileInput.files[0].title,
          description: this.newFile.description,
        })
      })
      this.files.push(uploadresponse);
      this.data.loading = false;
      this.initNewfile();
    } catch (err) {
      console.log(err);
      alert(err);
      this.data.loading = false;
      this.initNewfile();
    }
  }

  initNewfile() {
    this.newFile ??= Alpine.reactive({});
    this.newFile.title = '';
    this.newFile.document_type_id = null;
    this.newFile.description = '';
    this.newFile.file = null;
    // TODO: Input-Element resetten (per $refs?)
    if (this.fileInput) {
      this.fileInput.value = '';
    }
  }

  get base_url() {
    return this.options.base_url
  }

  get isLoading() {
    return this.data.loading === true;
  }
}

function getModifierValue(modifiers, key, defaultValue = null) {
  let index = modifiers.indexOf(key);
  if (index === -1 || modifiers.length < index + 2) {
    return defaultValue;
  }
  return modifiers[index + 1];
}

function getFilesController(el) {
  return Alpine.findClosest(el, (e) => e._x_fileuploader !== void 0)?._x_fileuploader;
}

export default function fileuploaderDocuments(Alpine) {
  Alpine.directive('fileuploader-documents', (el, {value, expression, modifiers}, {cleanup, evaluate}) => {
    switch (value) {
      case 'file':
        el._x_fileuploader_file = new FileController(getFilesController(el));
        break;
      case 'new-file':
        break;
      case 'file-input':
        getFilesController(el).fileInput = el;
        break;
      case null:
        let files = evaluate(expression);
        let options = {
          machine_id: getModifierValue(modifiers, 'machine_id', 0),
          maxsize: getModifierValue(modifiers, 'maxsize', 0),
          limit: getModifierValue(modifiers, 'limit', 0),
          base_url: el.dataset.fileuploaderDocumentsBaseUrl || '/offer/image/fileuploader/'
        }
        el._x_fileuploader = new FilesController(files, options);
    }
    cleanup(() => {
      delete el._x_fileuploader_file;
      delete el._x_fileuploader;
    })
  })
  Alpine.magic('fileuploader', (el, {Alpine}) => {
    let root = Alpine.findClosest(el, (e) => e._x_fileuploader !== void 0);
    return root._x_fileuploader;
  })
  Alpine.magic('fileuploaderFile', (el, {Alpine}) => {
    let root = Alpine.findClosest(el, (e) => e._x_fileuploader_file !== void 0);
    return root._x_fileuploader_file;
  })
}
